/* Auth wiring goes BEFORE everything else so the fetch interceptor catches
   any /api call made during module initialization, and so the user state
   is hydrated by the time render modules attach. */
import { installFetchInterceptor, loadUser } from './auth';
import { attachApiKeySync } from './modules/api-keys';
installFetchInterceptor();
attachApiKeySync();  // listen for user-changed before loadUser() fires it
loadUser();  // fire-and-forget; subscribers react

import './styles/index.css';
import { attachBackgroundPainter } from './modules/background-painter';
import { initConstellation } from './modules/constellation';
import { renderSelectedPills, updatePickerMeta } from './modules/selected-pills';
import { renderCostLegend } from './modules/cost-legend';
import { renderSynthModelSelect, renderSynthModes, attachSelectorHandlers } from './modules/render-selectors';
import { renderKeyRows, attachSettingsHandlers } from './modules/settings';
import { applyLang, attachLangSwitcher } from './modules/i18n';
import { updateRunButton, attachRunHandlers } from './modules/runner';
import { attachExports } from './modules/exports';
import { attachOptimalPromptHandlers } from './modules/optimal-prompt';
import { attachSynthesisHandlers } from './modules/synthesis';
import { attachHeaderUser } from './modules/header-user';
import { attachUpgradeModal } from './modules/upgrade-modal';
import { attachPickerPresetHandlers } from './modules/picker-presets';
import { attachSessionIoHandlers } from './modules/session-io';
import { attachAttachmentsHandlers } from './modules/attachments';
import { attachVoiceInputHandlers } from './modules/voice-input';
import { attachSessionRestoreHandler } from './modules/session-restore';
import { attachCloudSessionsHandlers } from './modules/cloud-sessions';
import { attachCheckoutReturnHandler } from './modules/checkout-return';
import { applyPersistedTheme, attachThemePickerHandlers } from './modules/theme-picker';

// Apply persisted theme BEFORE any DOM module renders so the user never
// sees a flash of the wrong theme.
applyPersistedTheme();
// Demo lives on its own page at /demo.html — see src/demo/main.ts.
// The header "▶ Demo" button is a plain anchor, so no JS wiring needed here.

/* React to the lang-changed custom event from i18n.applyLang(). */
window.addEventListener('lp-lang-changed', () => {
  updatePickerMeta();
  renderSynthModes();
  renderKeyRows();
  renderSelectedPills();
  renderCostLegend();
});

/* When BYOK keys finish hydrating from the backend, re-render the
 * settings drawer so the inputs show the synced values. */
window.addEventListener('lp-api-keys-hydrated', () => {
  renderKeyRows();
});

attachBackgroundPainter();
initConstellation();
renderSelectedPills();
renderCostLegend();
renderSynthModelSelect();
renderSynthModes();
renderKeyRows();
attachSettingsHandlers();
attachSelectorHandlers();
attachRunHandlers();
attachSynthesisHandlers();
attachExports();
attachOptimalPromptHandlers();
attachLangSwitcher();
attachHeaderUser();
attachUpgradeModal();
attachPickerPresetHandlers();
attachSessionIoHandlers();
attachAttachmentsHandlers();
attachVoiceInputHandlers();
attachSessionRestoreHandler();
attachCloudSessionsHandlers();
attachCheckoutReturnHandler();
attachThemePickerHandlers();

applyLang();
updateRunButton();
